export default __webpack_public_path__ + "static/media/Ballroll_00378.d6424216.png";